// react
import React from 'react'

// css
import '../../css/pages/Login.scss'

// dependencies
// import API from '@st-operations/uikit/API.js'
import { Link } from 'react-router-dom'
import User from '../lib/User.js'
import {
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  Divider,
  Section,
  BarLoader,
  Input,
} from '_root/src/v2/index.js'
// images
import google from '@st-operations/uikit/img/google@2x.png'
import left_img from '@st-operations/uikit/img/rectangle@3x.png'
import Storage from '@st-operations/uikit/Storage.js'

//contexts
import NavigationContext from '../contexts/NavigationContext.jsx'

// page
class LoginComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      error: null,
      error_msg: '',
      loading: false,
      password: '',
    }
    this.accountLogin = this.accountLogin.bind(this)
    this.facebookLogin = this.facebookLogin.bind(this)
    this.googleLogin = this.googleLogin.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount() {
    // hide side bar
    this.props.setShowSidebar(false)
    this.props.setShowContentContainer(false)

    if (window.mixpanel) {
      window.mixpanel.track('UIKit - Viewed Page', {
        path: this.props.location.pathname,
      })
    }

    // used to log login in app.js
    Storage.set('attempt_login', true)
  }

  componentWillUnmount() {
    this.props.setShowSidebar(true)
    this.props.setShowContentContainer(true)
  }

  facebookLogin() {
    this.setState({ loading: true })
    window._sso_api.redirect('/facebook/connect', {
      redirect: `${window.location.origin}/oauth.html`,
    })
    if (window.mixpanel) {
      window.mixpanel.track('UIKit - Logged In', {
        method: 'facebook',
      })
    }
  }

  googleLogin() {
    this.setState({ loading: true })
    window._sso_api.redirect('/google/connect', {
      redirect: `${window.location.origin}/oauth.html`,
    })
    if (window.mxipanel) {
      window.mixpanel.track('UIKit - Logged In', {
        method: 'google',
      })
    }
  }

  onChange(value, key) {
    let old_state = this.state
    old_state[key] = value
    this.setState({ old_state })
  }

  handleKeyPress(e) {
    if (e.key == 'Enter') {
      this.accountLogin()
    }
  }

  accountLogin() {
    const { email, password } = this.state
    this.setState({ loading: true })
    User.login(email, password, (error, user) => {
      if (error) {
        setTimeout(
          () =>
            this.setState({
              loading: false,
              error_msg: error.message,
            }),
          1000
        )
        return
      }
      // go to the dashboard page
      this.props.history.push('/')

      if (window.mixpanel) {
        window.mixpanel.track('UIKit - Logged In', {
          method: 'email',
        })
      }
    })
  }

  render() {
    const { logo, note, permission_text, title } = this.props
    let { error_msg, loading, email, password } = this.state

    let columns = window.innerWidth < 800 ? 1 : 2
    return (
      <div id="st-datasphere-login-page">
        <div className="st-datasphere-login-page__left">
          <img src={left_img} />
          <div className="st-datasphere-login-page__text--center">{title}</div>
          <div className="st-datasphere-login-page__note">{note}</div>
          <div className="st-datasphere-login-page__text--bottom">{permission_text}</div>
        </div>

        <div className="st-datasphere-login-page__content">
          <div className="st-datasphere-login-page__logo">
            <img src={logo} />
          </div>
          <h1>Login to Your Account</h1>
          <BarLoader
            className="st-datasphere-login-page__loading"
            containerStyle={{ opacity: loading ? 1 : 0 }}
          />
          <If condition={error_msg != ''}>
            <div className="st-datasphere-login-page__error">{error_msg}</div>
          </If>
          <Section className="st-datasphere-login-page__section st-datasphere-login-page__center st-datasphere-login-page__oauth">
            <div>
              <Button
                theme={BUTTON_THEME.GRAY}
                className="plain large small-text"
                onClick={this.googleLogin}
              >
                <img src={google} /> Continue with Google
              </Button>
            </div>
          </Section>
          <div className="st-datasphere-login-page__divider-container">
            <Divider />
            or
            <Divider />
          </div>
          <Section className="st-datasphere-login-page__section st-datasphere-login-page__email">
            <Input
              label="Email"
              onChange={(e) => this.onChange(e, 'email')}
              onKeyPress={this.handleKeyPress}
              placeholder="me@mydomain.com"
              value={email}
            />
          </Section>
          <Section className="st-datasphere-login-page__section st-datasphere-login-page__password">
            <Input
              onChange={(e) => this.onChange(e, 'password')}
              onKeyPress={this.handleKeyPress}
              placeholder="******"
              value={password}
              type="password"
              label="Password"
            />
            <Link className="st-datasphere-login-page__password--forgot" to="/forgot-password">
              Forgot your Password?
            </Link>
          </Section>
          <Section className="st-datasphere-login-page__section st-datasphere-login-page__center">
            <Button
              className="st-login-imram-button"
              theme={BUTTON_THEME.SECONDARY}
              size={BUTTON_SIZE.LARGE}
              onClick={this.accountLogin}
            >
              Login
            </Button>
          </Section>
        </div>
      </div>
    )
  }
}

const Login = (props) => (
  <NavigationContext.Consumer>
    {({ setShowSidebar, setShowContentContainer }) => (
      <LoginComponent
        {...props}
        setShowSidebar={setShowSidebar}
        setShowContentContainer={setShowContentContainer}
      />
    )}
  </NavigationContext.Consumer>
)

// export
export default Login
